import {
	StyledContainer,
	StyledHorizontalLine,
	StyledHorizontalLinesContainer,
	StyledVerticalLine,
	StyledVerticalLinesContainer,
} from './Grid.styled';

const Grid: React.FC = () => {
	return (
		<StyledContainer>
			<StyledVerticalLinesContainer>
				<div />
				{[...Array(3)].map((_, index) => (
					<StyledVerticalLine key={index} />
				))}
			</StyledVerticalLinesContainer>
			<StyledHorizontalLinesContainer>
				<div />
				{[...Array(3)].map((_, index) => (
					<StyledHorizontalLine key={index} />
				))}
			</StyledHorizontalLinesContainer>
		</StyledContainer>
	);
};

export { Grid };
